import { IconButton } from "@mui/material";
import React from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ClearIcon from "@mui/icons-material/Clear";
import theme from "@/theme";

export interface DrawerHeaderProps {
  handleBack?: () => void;
  text?: string;
  handleClose?: () => void;
  sticky?: boolean;
  variant?: "primary" | "light";
}

const DrawerHeader = ({
  handleBack,
  text,
  handleClose,
  sticky = false,
  variant = "primary",
}: DrawerHeaderProps) => (
  <div
    className={`flex h-16 w-full shrink-0 items-center justify-between px-4 ${
      variant === "light" ? "bg-white text-primary" : "bg-primary text-white"
    } ${sticky ? "sticky top-0 z-20" : ""}
    `}
    style={
      sticky
        ? {
            filter:
              "drop-shadow(0px 0px 20px hsl(var(--color-gray-900) / 0.2))",
          }
        : {}
    }
  >
    <div className="flex basis-2/12 items-center justify-start">
      {handleBack && (
        <IconButton
          size="large"
          onClick={handleBack}
          tabIndex={0}
          style={{ outline: "revert" }}
          aria-label="back to main drawer"
          color="inherit"
        >
          <ChevronLeftIcon className="transition hover:opacity-50" />
        </IconButton>
      )}
    </div>
    <div className="pointer-events-none flex basis-8/12 items-center justify-center">
      {text && (
        <h2 className="subtitle text-base font-semibold text-inherit">
          {text}
        </h2>
      )}
    </div>
    <div className="flex basis-2/12 items-center justify-end">
      {handleClose && (
        <IconButton
          size="large"
          onClick={handleClose}
          tabIndex={0}
          style={{ outline: "revert" }}
          aria-label="close"
          color="inherit"
        >
          <ClearIcon className="transition hover:opacity-50" />
        </IconButton>
      )}
    </div>
  </div>
);

export default DrawerHeader;
